module.exports = __webpack_public_path__ + "media/images/meta/testbrand/favicon-dddb5307ac457974de84a8419cef0c1d.png";